/* -------------------------------------------------------------------------- */
/* ---------------------------- MAP : FRAMEWORKS ---------------------------- */

// FRAMEWORKS : NODES_MODULES
import "leaflet";

/* -------------------------------------------------------------------------- */
/* --------------------------- MAP : GLOBAL EVENTS -------------------------- */

// DOCUMENT READY :
document.addEventListener("DOMContentLoaded", () => {
	initLeafletMap();
});

/* -------------------------------------------------------------------------- */
/* ------------------------- MAP : GLOBAL FUNCTIONS ------------------------- */

function isZipCode(inputString) {
	// Use a regular expression to match exactly five digits with no other characters
	return /^[0-9]{5}$/.test(inputString);
}

// Centrer une carte sur la position de l'utilisateur
function initialPosition(map) {
	const urlParams = new URLSearchParams(window.location.search);
	const city = urlParams.get("ville");
	if (city) {
		let nominatimUrl;
		// Utiliser l'API de Nominatim pour obtenir les coordonnées de la ville
		if (isZipCode(city)) {
			nominatimUrl = `https://nominatim.openstreetmap.org/search?country=France&postalcode=${encodeURIComponent(
				city
			)}&format=json&limit=1`;
		} else {
			nominatimUrl = `https://nominatim.openstreetmap.org/search?country=France&city=${encodeURIComponent(
				city
			)}&format=json&limit=1`;
		}

		fetch(nominatimUrl)
			.then((response) => response.json())
			.then((data) => {
				if (data.length > 0) {
					const lat = data[0].lat;
					const lon = data[0].lon;
					map.setView([lat, lon], 7);
				} else {
					console.error("La ville spécifiée n'a pas pu être trouvée.");
				}
			})
			.catch((error) =>
				console.error("Erreur lors de l'appel à l'API de Nominatim : " + error)
			);
	}
}

function geoloc() {
	if ("geolocation" in navigator) {
		navigator.geolocation.getCurrentPosition(
			function (position) {
				const userLatitude = position.coords.latitude;
				const userLongitude = position.coords.longitude;
				const url = window.location.protocol + '//' + window.location.host + window.location.pathname;
				window.location.href = url+'?lat='+userLatitude+'&lon='+userLongitude;
			},
			function (error) {
				console.error("Erreur de géolocalisation : " + error.message);
			}
		);
	} else {
		console.error(
			"La géolocalisation n'est pas prise en charge par ce navigateur."
		);
	}
}

// Leaflet : Initialisation de la map city
async function initLeafletMap() {
	const mapArea = document.querySelector("#reseau-city");
	const mapAreaExtra1 = document.querySelector("#reseau-city-extra-1");
	const mapAreaExtra2 = document.querySelector("#reseau-city-extra-2");

	const urlParams = new URLSearchParams(window.location.search);
	let lat = urlParams.get("lat");
	let lon = urlParams.get("lon");

	if(!lat) {
		lat = 48.8566;
		lon = 2.3522;
	}

	if (mapArea) {
		// Initialisation de la map
		const leafletMap = L.map(mapArea, {
			center: [lat, lon],
			zoom: 7,
			scrollWheelZoom: true,
		});
		L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
			leafletMap
		);

		const leafletMapExtra1 = L.map(mapAreaExtra1, {
			center: [-21.1249, 55.5181],
			zoom: 7,
			scrollWheelZoom: true,
		});
		L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
			leafletMapExtra1
		);

		const leafletMapExtra2 = L.map(mapAreaExtra2, {
			center: [14.6612, -61.0206],
			zoom: 7,
			scrollWheelZoom: true,
		});
		L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
			leafletMapExtra2
		);

		const url = window.location.origin;
		const searchParams = window.location.search;
		const jsonURL = `${url}/shops-json/?ajax=1&${searchParams.slice(
			1
		)}`;

		const response = await fetch(jsonURL).then((data) => {
			return data.json();
		});

		response["shops"].forEach((shop) => {
			if (!shop) {
				return;
			}

			const marker = L.marker([shop["latitude"], shop["longitude"]], {
				icon: L.divIcon({
					html: `
						<i style="transform: translate(-40%, -60%); filter: drop-shadow(13px 15px 10px rgba(0, 0, 0, 0.33))">
							<svg xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 0 39.7 48.88">
								<path fill="var(--color-secondary)" d="M19.85 0C8.89 0 0 8.89 0 19.85c0 7.44 6.7 17.12 19.85 29.03C33 37.22 39.7 27.29 39.7 19.85 39.7 8.89 30.81 0 19.85 0Zm.34 32.88c-7.73 0-14-6.27-14-14s6.27-14 14-14 14 6.27 14 14-6.27 14-14 14Z"/>
								<path fill="var(--color-light)" d="M20.19 4.88c-7.73 0-14 6.27-14 14s6.27 14 14 14 14-6.27 14-14-6.27-14-14-14Zm0 26c-6.29 0-11.45-4.84-11.96-11h23.92c-.51 6.16-5.67 11-11.96 11Z"/>
								<path fill="var(--color-primary)" d="M32.15 19.88c-.51 6.16-5.67 11-11.96 11s-11.45-4.84-11.96-11h23.92Z"/>
							</svg>
						</i>
					`,
				}),
			});

			if (shop["localisation"]["code_postal"] < 97000) {
				leafletMap.addLayer(marker);
			} else if (
				shop["localisation"]["code_postal"] > 97000 &&
				shop["localisation"]["code_postal"] < 97400
			) {
				leafletMapExtra2.addLayer(marker);
			} else {
				leafletMapExtra1.addLayer(marker);
			}

			var popup = `
				<div class="pin">
					<div class="pin__title">
						${shop["title"]}
					</div>
					<div class="pin__address">
						${shop["localisation"]["adresse"]}
						${shop["localisation"]["code_postal"]}
						${shop["localisation"]["ville"]}
					</div>
					<div class="pin__phone">
						${shop["phone"]}
					</div>
					<a class="pin__link" href="${shop["link"]}">
						<span>Voir la fiche magasin</span>
					</a>
				</div>
			`;
			marker.bindPopup(popup);
		});

		// Si possible, recentrer la map
		initialPosition(leafletMap);

		const geolocButton = document.querySelector("#geolocation");
		if (geolocButton) {
			geolocButton.addEventListener("click", () => {
				geoloc();
			});
		}
	}
}
